import * as React from 'react';
import { Panel } from './Panel';
import { Text } from './Text';
import { Button } from './Button';

/*
 * ErrorBoundary — catches a render crash anywhere under the routes and shows a
 * recoverable screen instead of React unmounting the whole app to a blank page.
 */

interface State {
  error?: Error;
}

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = {};

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Unhandled render error', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--space-4)',
        }}
      >
        <Panel style={{ maxWidth: 420, textAlign: 'center' }}>
          <Text as="h1" variant="heading">
            Something went wrong
          </Text>
          <Text as="p" variant="muted" style={{ margin: 'var(--space-3) 0 var(--space-5)' }}>
            {this.state.error.message}
          </Text>
          <Button variant="primary" onClick={() => window.location.assign('/')}>
            Back to start
          </Button>
        </Panel>
      </div>
    );
  }
}

export default ErrorBoundary;
